export default {
    data() {
        return {
            documentHeight: 0,
            headerHeight: 0,
            footerHeight: 0,
            scrollOffset: 0,
            screen: {
                vh: 0,
                vw: 0,
                sm: false,
                smDown: false,
                md: false,
                mdDown: false,
                lg: false,
                lgDown: false,
                xl: false,
                xlDown: false,
                xxl: false,
                xxlDown: false,
                xxxl: false,
            },
        };
    },

    mounted() {
        const self = this;

        // EVENT HANDLERS

        this.init()

        window.addEventListener('resize', () => {
            self.init();
        })

        window.addEventListener('orientationchange', () => {
            self.init();
        })

        document.addEventListener('lazyloaded', function (e) {
            self.calculateDocumentHeight();
        });
    },

    methods: {
        init() {
            this.screen.vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
            this.screen.vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

            this.screen.sm = this.screen.vw >= 576
            this.screen.smDown = this.screen.vw < 767.98
            this.screen.md = this.screen.vw >= 768
            this.screen.mdDown = this.screen.vw < 1023.98
            this.screen.lg = this.screen.vw >= 1024
            this.screen.lgDown = this.screen.vw < 1279.98
            this.screen.xl = this.screen.vw >= 1280
            this.screen.xlDown = this.screen.vw < 1439.98
            this.screen.xxl = this.screen.vw >= 1440
            this.screen.xxlDown = this.screen.vw < 1919.98
            this.screen.xxxl = this.screen.vw >= 1920

            const footer = document.getElementsByTagName("footer");

            if (footer.length > 0) {
                this.footerHeight = footer[0].clientHeight;
                document.documentElement.style.setProperty('--footerHeight', `${this.footerHeight}px`);
            } 

            const header = document.getElementsByTagName("header");

            if (header.length > 0) {
                this.headerHeight = header[0].clientHeight;
                document.documentElement.style.setProperty('--headerHeight', `${this.headerHeight}px`);
            }

            this.scrollOffset = this.headerHeight;
    
            this.calculateDocumentHeight();
        },

        calculateDocumentHeight() {
            const body = document.body,
                html = document.documentElement;

            this.documentHeight = Math.max(body.scrollHeight, body.offsetHeight,
                html.clientHeight, html.scrollHeight, html.offsetHeight);
        },
    }
};
